import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { products } from '@/mocks/products';
import ProductCard from './ProductCard';

export default function FeaturedProducts() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Show 2 products from each of first 4 categories (8 total)
  const categoriesToShow = ['Shoes', 'Hoodies/Sweaters', 'T-Shirts', 'Jackets'];
  const featured = categoriesToShow.flatMap((cat) => {
    const catProducts = products.filter((p) => p.category === cat);
    return catProducts.slice(0, 2);
  });

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-warm-900">
              {t('featuredProducts', 'Featured Products')}
            </h2>
            <p className="mt-1 text-sm text-warm-600">
              {t('productsSubtitle', 'Browse our curated collection from top brands')}
            </p>
          </div>
          <button
            onClick={() => { navigate('/products'); window.scrollTo(0, 0); }}
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-brand-500 text-white font-semibold text-sm rounded-lg hover:bg-brand-600 transition-colors whitespace-nowrap"
          >
            {t('viewAllProducts', 'View All Products')}
            <i className="ri-arrow-right-line" />
          </button>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {featured.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
}